import React from "react";

interface HeartIconProps {
  filled?: boolean;
  size?: number;
  color?: string;
}

export default function HeartIcon({ filled = false, size = 16, color = "#666" }: HeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 14.25l-1.45-1.32C3.4 9.36 1 7.28 1 4.5 1 2.42 2.42 1 4.5 1c1.24 0 2.45.54 3.5 1.41C9.05 1.54 10.26 1 11.5 1 13.58 1 15 2.42 15 4.5c0 2.78-2.4 4.86-5.55 8.43L8 14.25z"
        fill={filled ? "#e53e3e" : "none"}
        stroke={filled ? "#e53e3e" : color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}